import BlockPadding from '@/components/block-padding';
import { Button, Quote } from '@bumble/ui-kit';
import { useRouter } from 'next/router';

import styles from './quote-with-cta.module.scss';

export default function QuoteWithCta({ data }: { data: any }) {
  const router = useRouter();

  const {
    quote: { author, quote: quoteText },
    cta: { link, text },
  } = data || {};

  const localisedLink = link.includes('http') ? link : `${router.locale}${link}`;

  return (
    <BlockPadding maxWidth="small">
      <div className={styles.wrapper}>
        <div className={styles.quote}>
          <Quote text={quoteText} author={author} />
        </div>
        <div className={styles.cta}>
          <Button href={localisedLink} text={text} isInline={true} />
        </div>
      </div>
    </BlockPadding>
  );
}
